import React from 'react';
import { setCurrentView } from 'core/utils';
import { MarkAsShippedViewStore } from 'modules/order/stores';
import { MarkAsShippedTemplate } from 'themes/modules/order/pages';

@setCurrentView(
	(rootStore, componentProps) => new MarkAsShippedViewStore(rootStore, componentProps),
	'markAsShippedViewStore'
)
class MarkAsShipped extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <MarkAsShippedTemplate {...this.props} />;
	}
}

export default MarkAsShipped;
